import React from "react";
import { TimePicker } from ".";
import moment from "moment";
import { usePrevious } from "utilities";
import { Checkbox } from "./Atoms/inputs/Checkbox";

interface Props {
  value: moment.Moment
  onChange: (date: moment.Moment) => void
  autoFocus?: boolean
}

const OptionalTimePicker = (props: Props) => {
  // When we toggle the checkbox off and on, it'll be back at the same value
  const previousValue = usePrevious(props.value);

  // This state var manages the autofocus behavior for 2 scenarios:
  // 1. When the checkbox is checked, we want to focus on the time picker on the next render.
  // 2. For in-page editing, we want to focus on the time picker when the component is first rendered. In this case `props.autoFocus` should be true
  const [autoFocus, setAutoFocus] = React.useState<boolean>(props.autoFocus ?? false);

  const onDisplayChecked = (checked: boolean) => {
    if (checked) {
      // When the checkbox got checked, next render we must focus on the time picker
      setAutoFocus(true);
      if (previousValue == null) {
        props.onChange(moment.utc().startOf("day"));
      } else {
        props.onChange(previousValue);
      }
    } else {
      props.onChange(null);
    }
  };

  return <div className="flex gap-small">
    <div>
      <Checkbox
        className="margin-right-small"
        checked={props.value != null}
        onChange={(_, checked) => { onDisplayChecked(checked); }}
      />
    </div>
    {(props.value != null) && <div>
      <TimePicker
        value={props.value}
        onChange={props.onChange}
        autoFocus={autoFocus}
      />
    </div>}
  </div>;
};

export default OptionalTimePicker;